import React, {Component} from "react";
import {Router, Route, Link, Redirect, useLocation} from "react-router-dom"; // BrowserRouter as Router, 
import {createBrowserHistory} from "history";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronRight, faChevronLeft} from '@fortawesome/free-solid-svg-icons';
import TrayConfigurator from "./TrayConfigurator";
import AccessoryConfigurator from "./AccessoryConfigurator";
import ShoreConfigurator from "./ShoreConfigurator";
import ProjectStructure from "./ProjectStructure";
import ProjectManagement from "./ProjectManagement";
import ProjectItems from "./ProjectItems";
import ProductsBySwitcher from "./ProductsBySwitcher";
import ProductInfo from "./ProductInfo";
import {Store, Project, ProductsListsContext, ModalHelper, ConfirmModal, AlertModal, helper}  from "./../app.js"; 

const history = createBrowserHistory();
const ConfNavigation = (props) => 
{
    const location = useLocation();

    return <Row noGutters> 
        <Col md="auto" className="pb-2 pr-2 pb-md-3 pr-md-3">            
            <Link to={`${props.folder_path}tray`}><Button as="span" variant="outline-primary" className={location.pathname.search(/\/tray/) >= 0 ? 'active' : ''}>Лоток</Button></Link>            
        </Col>
        <Col md="auto" className="pb-2 pr-2 pb-md-3 pr-md-3">            
            <Link to={`${props.folder_path}accessories`}><Button as="span" variant="outline-primary" className={location.pathname.search(/\/accessories/) >= 0 ? 'active' : ''}>Аксессуары</Button></Link>
        </Col>
        <Col md="auto" className="pb-2 pr-2 pb-md-3 pr-md-3">            
            <Link to={`${props.folder_path}shore`}><Button as="span" variant="outline-primary" className={location.pathname.search(/\/shore/) >= 0 ? 'active' : ''}>Монтажная система</Button></Link>            
        </Col>
        <Col md className="pb-2 pb-md-3">            
            <Link to={`${props.folder_path}project`}><Button as="span" variant="outline-primary" className={(location.pathname.search(/\/project/) >= 0 ? 'active ' : '')+'float-md-right'}>Проект</Button></Link>
        </Col>
    </Row>;
}
const ConfStepsNav = (props) => 
{
    const location = useLocation();

    return <>
        {location.pathname.search(/\/accessories/) >= 0 
        ? <Button as="span" className="float-left step_nav_btn" variant="link">
            <FontAwesomeIcon icon={faChevronLeft} />
            <Link to={`${props.folder_path}tray`}>Шаг #1: Лотки</Link>                        
        </Button>
        : ''}
        {location.pathname.search(/(\/tray|\/shore)/) >= 0 
        ? <Button as="span" className={location.pathname.search(/\/shore/) >= 0  ? 'float-left step_nav_btn' : 'float-right step_nav_btn'} variant="link">
            {location.pathname.search(/\/shore/) >= 0 
            ? <FontAwesomeIcon icon={faChevronLeft} />
            : ''}
            <Link to={`${props.folder_path}accessories`}>Шаг #2: Аксессуары</Link>
            {location.pathname.search(/\/tray/) >= 0 
            ? <FontAwesomeIcon icon={faChevronRight} />
            : ''}
        </Button>
        : ''}
        {location.pathname.search(/\/accessories/) >= 0 
        ? <Button as="span" className="float-right step_nav_btn" variant="link">
            <Link to={`${props.folder_path}shore`}>Шаг #3: Монтаж</Link>
            <FontAwesomeIcon icon={faChevronRight} />
        </Button>
        : ''}
        {location.pathname.search(/(\/shore)/) >= 0 
        ? <Button as="span" className="float-right step_nav_btn" variant="link">
            <Link to={`${props.folder_path}project`}>Перейти к Проекту</Link>
            <FontAwesomeIcon icon={faChevronRight} />
        </Button>
        : ''}
    </>;
}
export default class CofiguratorApp extends Component 
{
    project = null;    
    modal = null;
    doSetProject = false;
    doGo2Home = false;

    constructor (props)
    {
        super(props);  
        
        const project = Project.instance;
        //console.log('project.init');
        project.init(this.props.init_project);
        this.project = project;        

        this.state = !helper.isNotObjectOrEmpty(this.props.init_configurator) ? this.props.init_configurator : CofiguratorApp.getInitState();

        if (!('fragment' in this.state) || !this.state.fragment)
        {
            this.state.fragment = Object.keys(this.project.fragments).shift();
            this.state.project_key = this.project.getHash();
            this.state.configurator_key = this.project.getHash(this.state.fragment);
        }
        this.project.curFragmentID = this.state.fragment;

        this.useItem = this.useItem.bind(this);
        this.setProductsListBy = this.setProductsListBy.bind(this);

        this.newProject = this.newProject.bind(this);
        this.setProducts = this.setProducts.bind(this);
        this.newFragment = this.newFragment.bind(this);
        this.useFragment = this.useFragment.bind(this);
        this.delFragment = this.delFragment.bind(this);
        
        this.modal = new ModalHelper(this);
        //ModalHelper.instance.init(this);
        this.modal.showAlert = this.modal.showAlert.bind(this.modal);
        this.modal.showConfirm = this.modal.showConfirm.bind(this.modal);
        this.modal.showProjectChangeWarning = this.modal.showProjectChangeWarning.bind(this.modal);
        this.modal.showTrayChangeWarning = this.modal.showTrayChangeWarning.bind(this.modal);

        globals._project = this.project;
        //globals._conf_state = this.state;
    }
    static getInitState ()
    {
        return {
            products_lists_by: 'articul',
            show_info_4product: null, 
            project_key: '',
            configurator_key: '',
            //fragment: null,

            tray_filter: {type: '', perforated: null, width: 0, height: 0},
            tray: null,
            tray_cover: null,
            tray_connector: null,

            accessories: [],

            shore_filter: {type: '', is_unitary: true, carrier_type: ''},
            shore_stud: null,
            shore_stud_conns: null,
            shore_stud_add: null,
            shore_stud_add_conns: null,
            shore_shelf: null,
            shore_shelf_conns: null,
            shore_stud_shelf_conns: null,
            shore_connector: null,
            shore_step: '', 
            shore_sect_count: '',

            alert_message: '',
            confirm_message: ''
        };
    }

    useItem (item, type, showInfo = true)
    {   
        const newState = {[type]: item};
        let setProjectWithNewState = false,
            doShowInfo = false;

        //console.log('useItem', newState, showInfo, this.project.data);

        switch (type)
        {
            case 'tray_filter':
            //case 'accessory_type':
                /*
                (prevState) => {
                    return {
                        strikes: prevState.strikes + 100
                    };
                }
                */
                this.setState(newState);                     
                // @todo часть фильтра будет происходить от одного компонента, часть от другого 

                break;

            case 'tray':

                if (null === item)
                {
                    this.setState(
                    {
                        tray: null,
                        tray_cover: null,
                        tray_connector: null,
                        accessories: [],
                        shore_stud: null,
                        shore_stud_conns: null,
                        shore_stud_add: null,
                        shore_stud_add_conns: null,
                        shore_shelf: null,
                        shore_shelf_conns: null,
                        shore_stud_shelf_conns: null,
                        shore_connector: null
                    });
                }
                else if ('quantity' in item)
                {
                    //this.doSetProject = true;
                    //this.setState(newState);   
                    setProjectWithNewState = true;                 
                }

                doShowInfo = showInfo;
                break;

            case 'accessory':    
                /*
                this.doSetProject = true;
                this.setState(prevState => 
                {
                    prevState.accessories.push(item);
                    //console.log('prevState.accessories', prevState.accessories);
                    return {
                        accessories: prevState.accessories
                    };
                });*/
                const tray = this.state.tray;
                let accessoryAdded = false;
                if (!helper.isNotObjectOrEmpty(tray))
                {
                    if (this.project.addAccessory4Tray(this.state.fragment, tray.id, item))
                    {
                        accessoryAdded = true;
                        Store.instance.set('project', this.project.data)
                                .then(() => 
                                {
                                    this.setState({'project_key':  this.project.getHash(), 'configurator_key':  this.project.getHash(this.state.fragment)});            
                                });
                    }
                }
                if (!accessoryAdded) this.modal.showAlert('Ошибка при добавлении аксессуара');//this.setState({alert_message: 'Ошибка при добавлении аксессуара'});
                break;

            case 'shore_filter':
            case 'shore_step':
            case 'shore_sect_count':

                this.setState(newState);                     
                break;

            case 'info':
                
                doShowInfo = showInfo;
                break;

            default:
                //console.log('default for', newState, type in this.state, null === item || 'quantity' in item || 'products' in item);

                if (type in this.state)
                {
                    if (null === item || 'quantity' in item || 'products' in item)
                    {
                        //this.doSetProject = true;
                        //this.setState(newState);                        
                        setProjectWithNewState = true;
                    }
                    doShowInfo = showInfo;
                }
                break;
        }

        //console.log('useItem before project set', newState, setProjectWithNewState);

        if (setProjectWithNewState)
        {
            this.doSetProject = true;
            this.setState(newState); 
        }

        if (doShowInfo)
        {
            this.setState({show_info_4product: item});
        }
    }

    setProductsListBy (by)
    {
        this.setState({products_lists_by: by});
    }

    newProject (params)
    {
        this.clearProject();
    }
    clearProject ()
    {
        const initState = CofiguratorApp.getInitState();

        //this.project = new Project();
        this.project.init();
        initState.fragment = this.project.curFragmentID = Object.keys(this.project.fragments).shift();

        Store.instance.set('project', {})
                .then(() => 
                {
                    return Store.instance.set('configurator', {})
                })
                .then(() => 
                {
                    //console.log(`${this.props.folder_path}tray`);
                    window.location.href = `${this.props.folder_path}tray`;
                });    
    }

    newFragment (params) 
    {
        const fragmentID = this.project.addFragment(params);
        Store.instance.set('project', this.project.data)
                .then(() => 
                {
                    this.useFragment(fragmentID);
                }); 
        
    }    
    delFragment (fragmentID)
    {
        const fragmentIDs = Object.keys(this.project.fragments);        

        this.project.delFragment(fragmentID);

        if (fragmentIDs.length > 1)
        {
            Store.instance.set('project', this.project.data)
                    .then(() => 
                    {
                        this.setState({'project_key':  this.project.getHash()});
                        if (fragmentID == this.state.fragment)
                        {
                            let useFragmentPos = fragmentIDs.indexOf(fragmentID) + 1;
                            if (fragmentIDs.length <= useFragmentPos)
                            {
                                useFragmentPos -= 2;
                            }
                            if (useFragmentPos < 0) useFragmentPos = 0;
                            this.useFragment(fragmentIDs[useFragmentPos]);
                        }                        
                    }); 
        }
        else
            this.clearProject();
    }
    useFragment (fragmentID)
    {
        const fragments = this.project.fragments;

        //console.log('useFragment 1', fragmentID, this.state.fragment, fragments);

        if (fragmentID != this.state.fragment && fragmentID in fragments)
        {
            //const newState = CofiguratorApp.getInitState();

            let newState = this.project.getFragmentConfState(fragmentID);

            if (helper.isNotObjectOrEmpty(newState)) newState = CofiguratorApp.getInitState();

            newState.fragment = this.project.curFragmentID = fragmentID;
            newState.project_key = this.project.getHash();
            newState.configurator_key = this.project.getHash(fragmentID); // this.state.fragment
            newState.show_info_4product = helper.copyObject(newState.tray);

            //console.log('useFragment 2', newState);

            this.doGo2Home = true;
            this.setState(newState);
        }        
    }

    setProducts (products)
    {
        this.project.setFragmentProducts(products);
        this.project.setFragmentAttr(this.project.curFragmentID, 'has_changed', true);
        Store.instance.set('project', this.project.data);
    }

    render() 
    {
        const tray = this.state.tray,
            hasTray = !helper.isNotObjectOrEmpty(tray),
            trayProps = {
                tray_filter: this.state.tray_filter,
                tray: this.state.tray,
                cover: this.state.tray_cover,
                connector: this.state.tray_connector
            },
            accessoryProps = {
                type: '',
                tray: this.state.tray,                
                accessory: null,
                cover: null,            
                connector: null
            },
            shoreProps = {
                tray_type: 'tray_filter' in this.state && 'type' in this.state.tray_filter ? this.state.tray_filter.type : '',
                tray_articul: hasTray ? tray.articul : '',
                tray_length: hasTray ? tray.length * tray.quantity : '',
                tray_width: hasTray ? tray.width : '',
                shore_filter: this.state.shore_filter,
                shore_stud: this.state.shore_stud, 
                shore_stud_add: this.state.shore_stud_add, 
                shore_stud_conns: this.state.shore_stud_conns?.products ?? this.state.shore_stud_conns,
                shore_stud_add_conns: this.state.shore_stud_add_conns?.products ?? this.state.shore_stud_add_conns,
                shore_shelf: this.state.shore_shelf,
                shore_shelf_conns: this.state.shore_shelf_conns?.products ?? this.state.shore_shelf_conns,
                shore_stud_shelf_conns: this.state.shore_stud_shelf_conns?.products ?? this.state.shore_stud_shelf_conns,
                shore_connector: this.state.shore_connector,
                shore_step: this.state.shore_step, 
                shore_sect_count: this.state.shore_sect_count
            },            
            showInfoProductId = !helper.isNotObjectOrEmpty(this.state.show_info_4product) 
                                    ? this.state.show_info_4product.id 
                                    : 'none';

        return (
            <><Router history={history}>
                <div className="pb-5">
                    <Container fluid className="mb-5">
                        <Row>   
                            <Col md={7} className='pl-md-0'>                                
                                <ConfNavigation folder_path={this.props.folder_path} />
                                <div className="bg-light rounded p-4 mb-3">
                                    <Redirect exact from={this.props.folder_path} to={`${this.props.folder_path}tray`} />
                                    <ProductsListsContext.Provider value={this.state.products_lists_by}>
                                        <Route path={`${this.props.folder_path}tray`} render={() => <TrayConfigurator on_select_item={this.useItem} {...trayProps} />} />
                                        <Route path={`${this.props.folder_path}accessories`} render={() => <AccessoryConfigurator on_select_item={this.useItem} {...accessoryProps} />} />
                                        <Route path={`${this.props.folder_path}shore`} render={() => <ShoreConfigurator on_select_item={this.useItem} {...shoreProps} />} />
                                    </ProductsListsContext.Provider>
                                    <Route path={`${this.props.folder_path}project`} render={() => <ProjectStructure key={`pstruc${this.state.project_key}-${this.state.fragment}`} project={this.project.structure} fragment={this.state.fragment} />} />
                                </div>                                
                                <ConfStepsNav folder_path={this.props.folder_path} />
                            </Col>
                            <Col md={5} className='pr-md-0'>
                                <div>
                                    <Route path={`${this.props.folder_path}(tray|accessories|shore)`} render={() => <ProductsBySwitcher on_switch={this.setProductsListBy} value={this.state.products_lists_by} />} />
                                    <Route path={`${this.props.folder_path}(tray|accessories|shore)`} render={() => <ProductInfo product={this.state.show_info_4product} key={`info4${showInfoProductId}`} />} />
                                    <Route path={`${this.props.folder_path}project`} render={() => <ProjectManagement key={`pmanag${this.state.project_key}`} on_new_project={this.newProject} on_new_fragment={this.newFragment} on_select_fragment={this.useFragment} 
                                        on_delete_fragment={this.delFragment} project={this.project.structure} products={this.project.products} fragments={this.project.fragments} />} />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Route path={`${this.props.folder_path}(tray|accessories|shore)`} render={() => <ProjectItems key={`pitems${this.state.configurator_key}`} on_change_products={this.setProducts} on_select_fragment={this.useFragment} products={this.project.getFragmentProducts(this.state.fragment)} 
                        fragments={this.project.fragments} fragment={this.state.fragment} can_set_count={false} can_delete={false} />} />
                    <Route path={`${this.props.folder_path}project`} render={() => <ProjectItems key={`pitems${this.state.configurator_key}`} on_change_products={this.setProducts} on_select_fragment={this.useFragment} products={this.project.getFragmentProducts(this.state.fragment)} 
                        fragments={this.project.fragments} fragment={this.state.fragment} can_set_count={true} can_delete={true} />} />
                </div>
            </Router>
            <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} />
            <ConfirmModal 
                on_close={() => this.setState({confirm_message: ''})} 
                on_ok={this.state.on_confirm} 
                on_cancel={() => this.setState({confirm_message: ''})} 
                message={this.state.confirm_message} /></>
        );
    }
    componentDidUpdate () 
    {
        const storeConf = helper.copyObject(this.state);

        if (!helper.isNotObjectOrEmpty(storeConf.tray))
        {
            storeConf.show_info_4product = helper.copyObject(storeConf.tray);
        }
        Store.instance.set('configurator', storeConf)
                .then(() =>
                {
                    if (this.doSetProject)
                    {
                        this.project.setFragmentProductsByConfigurator(this.state);
                        Store.instance.set('project', this.project.data)
                                .then(() => 
                                {
                                    this.doSetProject = false;
                                    this.setState({'project_key':  this.project.getHash(), 'configurator_key':  this.project.getHash(this.state.fragment)});            
                                });
                    }
                    
                    if (this.doGo2Home)
                    {
                        this.doGo2Home = false;
                        history.push(`${this.props.folder_path}tray`);
                    }
                });
    }
}
